import script from "./CrudPedidosSeguimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudPedidosSeguimiento.vue?vue&type=script&setup=true&lang=js"

import "./CrudPedidosSeguimiento.vue?vue&type=style&index=0&id=23a793ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a793ef"]])

export default __exports__